import { adminInstance } from "@/api/instance";

export default async function (reviewId, data) {
  return adminInstance.put(`/review/${reviewId}`, data);
}
